module.exports = __webpack_public_path__ + "static/tcc-logo-8fb139710d7fc462ec9910786d980846.png";